<wiz-vgroup width="100%" height="100%" gap="2" class="section-container">
  <wiz-vgroup horizontalAlign="center" width="100%" padding=" 0 15px">
    <wiz-hgroup horizontalAlign="space-between" width="100%">
      <wiz-label class="smallTitleLabel" [wizLabel]="'$.phys-template.creation.title.$'"></wiz-label>
      <wiz-icon class="image-purple" (click)="hide()">close</wiz-icon>
    </wiz-hgroup>

    <wiz-vgroup wizValidationContainer padding="10px" width="100%" height="100%">
      <!-- <wiz-dropdown wizValidator #ddlVision [wizDataProvider]="visionDatasource" [wizLabelField]="'trsLabel'"
        [wizMandatory]=true wizLabel="$.phys-template.vision.$" width="100%"></wiz-dropdown> -->
      <wiz-text-input
        width="100%"
        #tiCode
        class="upper-case-input"
        wizValidator
        wizMandatory="true"
        wizLabel="$.common.code.$"
        [wizMaxChars]="20"
      ></wiz-text-input>

      <wiz-dropdown #ddClone
        [wizLabel]="'$.template.clone.$'"
        [wizLabelField]="'code'"
        [wizDataProvider]="templateDS"></wiz-dropdown>

      <wiz-translation-basic
        #tiLabel
        wizValidator
        [wizMandatory]="true"
        [maxTranslation]="6"
        [wizLabel]="'$.common.label.$'"
        [wizPlaceholder]="'$.common.define.$'"
        width="100%"
      ></wiz-translation-basic>
      <wiz-translation-basic
        #taDescription
        [wizTranslationMode]="'textarea'"
        [maxTranslation]="6"
        [wizLabel]="'$.common.description.$'"
        [wizPlaceholder]="'$.common.define.$'"
        width="100%"
        height="100px"
      ></wiz-translation-basic>
      <wiz-spacer height="100%"></wiz-spacer>
      <wiz-hgroup width="100%" horizontalAlign="end">
        <wiz-button width="200px"
          [wizLabel]="'$.common.validate.$'"
          (wizClick)="validate()"
          [wizDisabled]="!isValidable"
        ></wiz-button>
      </wiz-hgroup>
    </wiz-vgroup>

  </wiz-vgroup>
</wiz-vgroup>